import { css } from '@emotion/css';

// noinspection CssUnknownTarget
export default css`
  @import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css');
  
  @font-face {
    font-family: 'Spoqa Han Sans';
    src: local('Spoqa Han Sans Bold'), url('/fonts/SpoqaHanSansNeo-Bold.woff2') format('woff2'),
      url('/fonts/SpoqaHanSansNeo-Bold.woff') format('woff'), url('/fonts/SpoqaHanSansNeo-Bold.ttf') format('truetype');
    font-display: block;
    font-weight: 700;
  }
  @font-face {
    font-family: 'Spoqa Han Sans';
    src: local('Spoqa Han Sans Medium'), url('/fonts/SpoqaHanSansNeo-Medium.woff2') format('woff2'),
      url('/fonts/SpoqaHanSansNeo-Medium.woff') format('woff'),
      url('/fonts/SpoqaHanSansNeo-Medium.ttf') format('truetype');
    font-display: block;
    font-weight: 500;
  }
  @font-face {
    font-family: 'Spoqa Han Sans';
    src: local('Spoqa Han Sans Regular'), url('/fonts/SpoqaHanSansNeo-Regular.woff2') format('woff2'),
      url('/fonts/SpoqaHanSansNeo-Regular.woff') format('woff'),
      url('/fonts/SpoqaHanSansNeo-Regular.ttf') format('truetype');
    font-display: block;
    font-weight: 400;
  }
  @font-face {
    font-family: 'Spoqa Han Sans';
    src: local('Spoqa Han Sans Light'), url('/fonts/SpoqaHanSansNeo-Light.woff2') format('woff2'),
      url('/fonts/SpoqaHanSansNeo-Light.woff') format('woff'),
      url('/fonts/SpoqaHanSansNeo-Light.ttf') format('truetype');
    font-display: block;
    font-weight: 300;
  }
  @font-face {
    font-family: 'Spoqa Han Sans';
    src: local('Spoqa Han Sans Thin'), url('/fonts/SpoqaHanSansNeo-Thin.woff2') format('woff2'),
      url('/fonts/SpoqaHanSansNeo-Thin.woff') format('woff'), url('/fonts/SpoqaHanSansNeo-Thin.ttf') format('truetype');
    font-display: block;
    font-weight: 100;
  }
`;
